import { render, staticRenderFns } from "./ChatbotComposer.vue?vue&type=template&id=cbe5e470&scoped=true&"
import script from "./ChatbotComposer.vue?vue&type=script&lang=js&"
export * from "./ChatbotComposer.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotComposer.vue?vue&type=style&index=0&id=cbe5e470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe5e470",
  null
  
)

export default component.exports